<div class="container-fluid">
    <h1 class="page-header">Student Inventory</h1>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Filter
        </mat-panel-title>
        <mat-panel-description>
          <app-filter-results-panel [parameters]="queryParams"></app-filter-results-panel>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
        <div class="row">

          <div class="col-12 col-sm-6 col-lg">
            <mat-form-field class="full-width-field">
              <mat-label>Select Department...</mat-label>
              <mat-select name="field_student_department_target_id" ngModel (selectionChange)="onSubmit(f)">
                <mat-option value="All">All</mat-option>
                <mat-option *ngFor="let department of departmentData" [value]="department.key">{{ department.value }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-12 col-sm-6 col-lg">
            <mat-form-field class="full-width-field">
              <mat-label>Last Lesson Taken Start</mat-label>
              <input matInput (click)="pickerMin.open()" [ngxMatDatetimePicker]="pickerMin" name="last_lesson_taken_start" [(ngModel)]="lastLessonTakenStart" (dateChange)="updatePickerMax($event)" [disabled]="isActiveChecked || isInactiveChecked">
              <mat-datepicker-toggle matSuffix [for]="pickerMin"></mat-datepicker-toggle>
              <ngx-mat-datetime-picker #pickerMin [hideTime]="true" [enableMeridian]="true" [showSpinners]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="15" [touchUi]="false"></ngx-mat-datetime-picker>
            </mat-form-field>
          </div>

          <div class="col-12 col-sm-6 col-lg">
            <mat-form-field class="full-width-field">
              <mat-label>Last Lesson Taken End</mat-label>
              <input matInput (click)="pickerMax.open()" [ngxMatDatetimePicker]="pickerMax" name="last_lesson_taken_end" [(ngModel)]="lastLessonTakenEnd" (dateChange)="onSubmit(f)" [disabled]="isActiveChecked || isInactiveChecked">
              <mat-datepicker-toggle matSuffix [for]="pickerMax"></mat-datepicker-toggle>
              <ngx-mat-datetime-picker #pickerMax [hideTime]="true" [enableMeridian]="true" [showSpinners]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="15" [touchUi]="false"></ngx-mat-datetime-picker>
            </mat-form-field>
          </div>

          <section class="section">
            <mat-checkbox name="Active" class="margin" [(ngModel)]="isActiveChecked" (change)="onActiveChange()">Active</mat-checkbox>
            <mat-checkbox name="Inactive" class="margin" [(ngModel)]="isInactiveChecked" (change)="onInactiveChange()">Inactive</mat-checkbox>
          </section>

          <section class="section">
            <div class="float-end bring-inline">
              <button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear</button>
            </div>
          </section>

        </div>
      </form>
    </mat-expansion-panel>

    <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>
    <div class="row">
      <div class="col-md-12 mt-3">
        <div class="float-end">
          <button (click)="downloadStudentsInventoryReport()" color="primary" mat-flat-button class="me-1 warning" mat-button>
            <mat-icon *ngIf="isLoading" class="mat-icon-animate-spin">autorenew</mat-icon>
            <ng-container *ngIf="!isLoading">
              <mat-icon>file_download</mat-icon>
              <span>Export CSV</span>
            </ng-container>
            <span *ngIf="isLoading">Exporting...</span>
          </button>
          <button style="background-color: transparent !important; border: none;"
            (click)="printStudentInventory()"
            type="button"
            mat-icon-button
            [disabled]="isLoading"
            class="me-1 mb-1"
            matTooltip="Print students inventory"
            matTooltipPosition="below"
            aria-label="Print students inventory">
            <mat-icon style="color: #1C3F8B;">print</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive-sticky table-responsive">

        <table mat-table #displayTable [dataSource]="dataSource"
            matSort
            (matSortChange)="sortDataView($event)"
            class="mt-4">

            <!-- name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef
                    mat-sort-header="field_last_name_value"
                    sortActionDescription="Sort by name">
                    Full Name of Client
                </th>
                <td mat-cell *matCellDef="let element">
                    {{element.field_last_name}}, {{element.field_first_name}}
                    <div class="small text-muted" *ngFor="let c of secondaryContacts(element)">
                        {{c.last_name}}, {{c.first_name}}
                    </div>
                </td>
            </ng-container>

            <!-- field_student_department -->
            <ng-container matColumnDef="field_student_department">
                <th mat-header-cell *matHeaderCellDef
                    mat-sort-header="field_student_department_target_id"
                    sortActionDescription="Sort by field_student_department">
                    Dept.
                </th>
                <td mat-cell *matCellDef="let element"> {{element.field_student_department}} </td>
            </ng-container>


            <!-- address Column -->
            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by address">
                    Complete Address
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.field_address_address_line1 }}
                    {{ element.field_address_address_line2 }}
                    {{ element.field_address_administrative_area }}
                    {{ element.field_address_postal_code }}
                </td>
            </ng-container>

            <!-- totalEnrolled Column -->
            <ng-container matColumnDef="totalEnrolled">
                <th mat-header-cell *matHeaderCellDef
                    mat-sort-header="field_total_lessons_enrolled_value"
                    sortActionDescription="Sort by totalEnrolled">
                    Total PER Lessons Enrolled (45-Minute)
                </th>
                <td mat-cell *matCellDef="let element"> {{element.field_total_lessons_enrolled}} </td>
            </ng-container>

            <!-- lessonUsed Column -->
            <ng-container matColumnDef="lessonUsed">
                <th mat-header-cell *matHeaderCellDef
                    mat-sort-header="field_total_lessons_taken_all_value"
                    sortActionDescription="Sort by lessonUsed">
                    Total PRI Lessons Used
                </th>
                <td mat-cell *matCellDef="let element"> {{element.field_total_lessons_taken_all}} </td>
            </ng-container>

            <!-- remaining Column -->
            <ng-container matColumnDef="remaining">
                <th mat-header-cell *matHeaderCellDef
                    mat-sort-header="field_total_lessons_remaining_value"
                    sortActionDescription="Sort by remaining">
                    No. Of Untaught PRI Lessons
                </th>
                <td mat-cell *matCellDef="let element"> {{element.field_total_lessons_remaining}} </td>
            </ng-container>

            <!-- Misc. Serv. Type & Value Column -->
            <ng-container matColumnDef="miscService">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by remaining">
                    Misc. Serv. Type & Value
                </th>
                <td mat-cell *matCellDef="let element">
                    <div [innerHTML]="element.misc_services_field"></div>
                </td>
            </ng-container>

            <!-- totalDue Column -->
            <!-- <ng-container matColumnDef="totalDue">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by remaining">
                    Total $ Due
                </th>
                <td mat-cell *matCellDef="let element"> ${{ element.field_balance_due }} </td>
            </ng-container> -->

            <!-- total_due_misc_field Column -->
            <ng-container matColumnDef="total_due_misc_field">
                <th mat-header-cell *matHeaderCellDef
                    mat-sort-header="total_due_misc_field"
                    sortActionDescription="Sort by total misc due" class="text-end">
                    Total Misc $ Due
                </th>
                <td mat-cell *matCellDef="let element" class="text-end"> {{ element.total_due_misc_field | studioCurrency }} </td>
            </ng-container>

            <!-- totalDueLessons Column -->
            <ng-container matColumnDef="totalDueLessons">
                <th mat-header-cell *matHeaderCellDef
                    mat-sort-header="total_due_lessons_field"
                    sortActionDescription="Sort by total lesson due" class="text-end">
                    Total Lesson $ Due
                </th>
                <td mat-cell *matCellDef="let element" class="text-end"> {{ element.total_due_lessons_field | studioCurrency }} </td>
            </ng-container>

            <!-- lastLesson Column -->
            <ng-container matColumnDef="lastLesson">
                <th mat-header-cell *matHeaderCellDef
                    mat-sort-header="field_last_lesson_taken_value"
                    sortActionDescription="Sort by lastLesson">
                    Date of Last Lesson Taught
                </th>
                <td mat-cell *matCellDef="let element"> {{ reportDateService.formatDate(element.field_last_lesson_taken) }} </td>
            </ng-container>

            <!-- lastLesson Column -->
            <ng-container matColumnDef="futureLesson">
                <th mat-header-cell *matHeaderCellDef
                    mat-sort-header="field_upcoming_lesson_value"
                    sortActionDescription="Sort by futureLesson">
                    Date of Future Lesson
                </th>
                <td mat-cell *matCellDef="let element"> {{ reportDateService.formatDate(element.field_upcoming_lesson) }} </td>
            </ng-container>


            <!-- test Column -->
            <!-- <ng-container matColumnDef="test">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by test">
                    Total $ Due Studio & Budget
                </th>
                <td mat-cell *matCellDef="let element"> {{element.test}} </td>
            </ng-container> -->

            <!-- Footer for pagination -->
            <ng-container matColumnDef="pagination-footer">
                <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
                    <mat-paginator
                        [disabled]="ShowProgressBar"
                        (page)="pageChanged($event)"
                        [pageSizeOptions]="onPageSizeOptions()"
                        [length]="30"
                        [pageSize]="paginationTotalPages"
                        [pageIndex]="paginationIndex"
                        aria-label="Select page of view"></mat-paginator>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="['pagination-footer']; sticky: true"></tr>
        </table>

    </div>
</div>
